import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import {
	Route,
	Routes,
	useNavigate
} from 'react-router-dom';
import { Main } from '../Main/Main';

import { useTranslation } from 'react-i18next';
import { RegisterPage } from '../Register/Register';
import { ChangePasswordPage } from '../ChangePasswordPage/ChangePasswordPage';
import { ResetPassPage } from './../ResetPassPage/ResetPassPage';

export const App: React.FC = () => {

	const {i18n} = useTranslation();
	const navigate = useNavigate();

	React.useEffect(() => {
		const locationArr = location.pathname.split('/');
		if (locationArr[1] === 'assets') {
			return;
		}
		const lang = locationArr[1];
		if (!lang) {
			navigate(`${i18n.language}/auth/sing-up/`);
		}
		
		if (lang && lang === 'ru' || lang === 'en') {
			i18n.changeLanguage(lang);
		} else {
			navigate(`${i18n.language}/${locationArr.slice(1).join('/')+location.search}`);
		}
	}, []);
	
	React.useEffect(() => {
		const locationArr = location.pathname.split('/');
		if (locationArr[1] === 'assets') {
			return;
		}
		if (locationArr[1] !== i18n.language) {
			navigate(`${i18n.language}/${locationArr.slice(2).join('/')}`);
		}
		if (!locationArr[2] || !locationArr[3]) {
			navigate(`${i18n.language}/auth/sign-up/`);
		}
	}, [i18n.language]);
	
	return <React.StrictMode>
		<React.Suspense fallback='loading'>
			<Routes>
				<Route index element={<Main />} />
				<Route path=':lang/auth/sign-up/' element={<RegisterPage />} />
				<Route path=':lang/auth/change-pass/' element={<ChangePasswordPage />} />
				<Route path=':lang/auth/reset-pass/' element={<ResetPassPage />} />
				{/**/}
			</Routes>
		</React.Suspense>
		
	</React.StrictMode>;
};
